import { render, staticRenderFns } from "./switcherAIcon.vue?vue&type=template&id=52ca85c8&"
import script from "./switcherAIcon.vue?vue&type=script&lang=js&"
export * from "./switcherAIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports